export const BUSINESS_INFO = {
  name: "Hundens Pels og Pleje",
  cvr: "25332261",
  phone: "61 69 31 89",
  phoneRaw: "61693189",
  phoneHours: "Kl. 8.00 - 8.30 (send gerne en SMS uden for telefontid)",
  email: "hundenspelsogpleje@gmail.com",
  address: "Brovadvej 56, 7000 Fredericia",
  street: "Brovadvej 56",
  city: "7000 Fredericia",
  facebookUrl: "https://www.facebook.com/profile.php?id=61593882904298&locale=da_DK",
  bookingUrl: "https://hundenspelsogpleje.onlinebooq.dk/?fbclid=IwY2xjawUMsGtwZG9mBWV4dG4DYWVtAjEwAGJyaWQRMTRqV2tzb3IwemlmaVpoa2FzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEerkf9PUJjnhEOu8UQiNvv-rEDdo7zKby_neqWYfZlslXFUsBrqr5ob377YdQ_aem_2PdRxopSvHSfnIMapFR7cg",
  hours: "Efter aftale via online booking",
  owner: "Trine",
  logoUrl: "https://assets.auxodev.dk/assets/9e509bf9-9216-49e7-9224-6ccd4f39c4eb/skaermbillede-2026-09-08-kl-11-12-29.png",
};

export const API_BASE_URL = "https://api.dev.auxo.dk";

export const NAV_LINKS = [
  { label: "Forside", path: "/" },
  { label: "Ydelser & priser", path: "/ydelser-priser" },
  { label: "Hvalpepakke", path: "/hvalpepakke" },
  { label: "Galleri", path: "/galleri" },
  { label: "Om os", path: "/om-os" },
  { label: "Kontakt", path: "/kontakt" },
];
